export const getSelectedSubApplications = (formStore, applicationTopicGroup) => {
    const selectedApplications = formStore.state.selectedApplications || [];
    const subApplications = [];
    applicationTopicGroup.children
        .filter((application) => selectedApplications.includes(application.id))
        .map((application) => { var _a; return (_a = application.children) === null || _a === void 0 ? void 0 : _a.forEach((group) => subApplications.push(group)); });
    return subApplications;
};
//# sourceMappingURL=getSelectedSubApplications.js.map
